/* Mirrors backend USER_ROLE_TYPES in configs/constants/database.constant.ts */
export const USER_ROLE_TYPES = {
  admin: 1,
  project_manager: 2,
  supervisor: 3,
} as const;

export const USER_ROLE_LABELS: Record<number, string> = {
  [USER_ROLE_TYPES.admin]: "Admin",
  [USER_ROLE_TYPES.project_manager]: "Project Manager",
  [USER_ROLE_TYPES.supervisor]: "Supervisor",
};

/* Role_type_ids in the "supervisor+" bucket — Admin, PM, Supervisor. Used for attendance participant gating. */
export const SUPERVISOR_ROLE_TYPE_IDS: readonly number[] = [
  USER_ROLE_TYPES.admin,
  USER_ROLE_TYPES.project_manager,
  USER_ROLE_TYPES.supervisor,
];

export type UserRoleTypeId = (typeof USER_ROLE_TYPES)[keyof typeof USER_ROLE_TYPES];

/* Mirror of backend SUPER_ADMIN_USER_IDS — parsed from VITE_SUPER_ADMIN_USER_IDS. Accepts "1,2" or "[1,2]". UI-only gate; backend enforces. */
export const SUPER_ADMIN_USER_IDS: number[] = (import.meta.env.VITE_SUPER_ADMIN_USER_IDS ?? "")
  .replace(/[\[\]\s]/g, "")
  .split(",")
  .map((raw: string) => Number(raw))
  .filter((value: number) => Number.isInteger(value) && value > 0);

export const isSuperAdminUser = (user_id: number | null | undefined): boolean => {
  if(user_id === null || user_id === undefined) return false;

  return SUPER_ADMIN_USER_IDS.includes(user_id);
};
